import parse from "html-react-parser";
import options from "../../support/parse-settings";

const ContentParser = ({ content }) => {
  return <>{parse(content, options)}</>;
};

export default ContentParser;
